import { withErrorBoundary } from "@/components/hoc";
import { EmailVerification, PasswordReset } from "@/components/email-actions";
import { Styled } from "./styles";
import { Box } from "@mui/material";
import constant from "@/utils/constant";

const EmailActions: React.FC = () => {
    const decode = decodeURIComponent(window.location.href);
    const params = new URL(decode).searchParams;

    const mode = params.get("mode");
    const oobCode = params.get("oobCode");
    const { dippiLogo } = constant.ASSETS;

    return (
        <Styled.Container>
            <img src={dippiLogo} width={85} alt="dippi logo" />
            <Box margin="25px 0px">
                {mode === "verifyEmail" ? (
                    <EmailVerification oobCode={oobCode} />
                ) : mode === "resetPassword" ? (
                    <PasswordReset oobCode={oobCode} />
                ) : null}
            </Box>
        </Styled.Container>
    );
};

export default withErrorBoundary({ component: "EmailActions" })(EmailActions);
